var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleInfoSmallfilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 12.4182 3.58182 16 8 16C12.4182 16 16 12.4182 16 8C16 3.58145 12.4182 0 8 0C3.58182 0 0 3.58145 0 8ZM8 6C8.55229 6 9 6.44772 9 7V12.3333C9 12.8856 8.55229 13.3333 8 13.3333C7.44772 13.3333 7 12.8856 7 12.3333V7C7 6.44772 7.44772 6 8 6ZM7 3.66651C7 3.11427 7.44784 2.66666 8 2.66666C8.55216 2.66666 9 3.11427 9 3.66651C9 4.21904 8.55216 4.66666 8 4.66666C7.44784 4.66666 7 4.21904 7 3.66651Z",
    fill: "#9EB25D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleInfoSmallfilled);
export default __webpack_public_path__ + "static/media/Circle Info - Small (filled).2d87f2176204d32388429ee6c104e18e.svg";
export { ForwardRef as ReactComponent };